export type ResourceId = "focus" | "clarity" | "resilience";

export type ResourceSnapshot = Record<ResourceId, number>;

export const RESOURCE_LABELS: Record<ResourceId, string> = {
  focus: "Focus",
  clarity: "Clarity",
  resilience: "Resilience",
};

export function createEmptyResources(): ResourceSnapshot {
  return { focus: 0, clarity: 0, resilience: 0 };
}
